import script from "./AchievementsList.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementsList.vue?vue&type=script&setup=true&lang=js"

import "./AchievementsList.vue?vue&type=style&index=0&id=244a8d8e&lang=scss"

const __exports__ = script;

export default __exports__